import http from 'hub-http/clients/apiClient';
import { deleteCampaign as deleteCampaignRpc } from 'campaigns-utils-lib/data/CampaignDaoChirp';
import { OBJECT_TYPE } from 'asset-actions-lib/constants/objectTypes';
import { getPropertyValue } from 'asset-actions-lib/utils/crmObject';
function deleteCampaign(crmObject) {
  const campaignGuid = getPropertyValue(crmObject, 'hs_origin_asset_id');
  if (!campaignGuid) {
    return Promise.reject(new Error('Missing hs_origin_asset_id on campaign CRM object'));
  }
  return deleteCampaignRpc(campaignGuid);
}
function deleteSms(crmObject) {
  const smsObjectId = getPropertyValue(crmObject, 'hs_content_id');
  return http.delete(`messaging-sms/v1/sms/${smsObjectId}`);
}
function deleteMarketingEvent(crmObject) {
  const objectId = getPropertyValue(crmObject, 'hs_object_id');
  return http.post('inbounddb-objects/v2/batch-mutation/dynamic-search', {
    data: {
      type: 'DELETE',
      objectTypeId: OBJECT_TYPE.MARKETING_EVENT,
      objectIdList: [`${objectId}`]
    }
  });
}

// TODO: Add api calls for missing asset types
export default function deleteAsset(crmObject) {
  switch (crmObject.objectTypeId) {
    case OBJECT_TYPE.CAMPAIGN:
      return deleteCampaign(crmObject);
    case OBJECT_TYPE.MARKETING_EVENT:
      return deleteMarketingEvent(crmObject);
    case OBJECT_TYPE.MARKETING_SMS:
      return deleteSms(crmObject);
    default:
      return Promise.resolve();
  }
}